import React from "react";
import { ECLBlockument } from "../../../../eclComponents";
import FilePreview from "./FilePreview";

export default function ExplorerPreview({ node }) {
   switch (node?.data?.object_type) {
      case "document":
         return (
            <ECLBlockument
               object={{
                  id: node.id,
                  name: node.data.name,
               }}
               project={{}}
            />
         );
      case "file":
         return <FilePreview node={node} />;

      default:
         return <p>no preview</p>;
   }
}
